import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

console.log('WIH ADA HEKERRRRRRR NGERIII TAKUT')
console.log('WEB NYA JANGAN DI APA APAIN YA DEK, JANGAN DI HACK HACK KASIAN YANG LAIN GABISA MAKE NTAR')
console.log('-G')

ReactDOM.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
	document.getElementById('root')
);
